/**
 * useVisitorId — identifiant stable pour les utilisateurs anonymes
 *
 * - Retourne immédiatement un UUID depuis localStorage (jamais null)
 * - Améliore ensuite avec FingerprintJS (stable même en navigation privée)
 * - Le fingerprint est stocké dans localStorage pour les visites suivantes
 */

import { useState, useEffect } from 'react';

const STORAGE_KEY = 'sl_visitor_id';

function getOrCreateLocalId(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
    const id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    // localStorage bloqué (rare) — UUID éphémère
    return crypto.randomUUID();
  }
}

export function useVisitorId(): string {
  const [visitorId, setVisitorId] = useState<string>(getOrCreateLocalId);

  useEffect(() => {
    // Améliore l'ID avec FingerprintJS (stable en incognito, cross-session)
    import('@fingerprintjs/fingerprintjs')
      .then(FingerprintJS => FingerprintJS.load())
      .then(fp => fp.get())
      .then(result => {
        try {
          localStorage.setItem(STORAGE_KEY, result.visitorId);
        } catch { /* stockage indisponible (navigation privée) */ }
        setVisitorId(result.visitorId);
      })
      .catch(() => {
        // FingerprintJS bloqué (ad-blocker, etc.) → on garde l'UUID
      });
  }, []);

  return visitorId;
}
